import { StyleSheet } from 'react-native'
import { layoutStyles } from '@/presentation/styles/globals'

export const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  content: {
    ...layoutStyles.pageContent
  }
})
